<template>
    <div v-show="store.state.currentTab === 'Settings'" class="menu-content" id="view-settings">
        <h1 class="themed-title">{{t('settings title','Settings')}}</h1>
        <div class="form-option">
            <label>{{t('theme selection','Theme')}}</label>
            <select v-model="selectedTheme" @change="setTheme">
                <option v-for="(theme, i) in themes" :key="i" :value="theme.name">
                    {{ theme.displayName }}
                </option>
            </select>
        </div>
        <div class="form-option">
            <label>{{t('units selection', 'Units')}}</label>
            <select v-model="selectedUnits" @change="setUnits">
                <option value="cm">cm</option>
                <option value="inch">inch</option>
            </select>
        </div>
        <div class="form-option" v-for="(option, i) in options" :key="i">
            <label :for="option.key">{{ t(option.translateKey, option.translateDefault) }}</label>
            <input type="checkbox" :id="option.key" v-model="this[option.key]" @change="setOption(option.key)">
        </div>
        <div v-show="showGuides" class="highlighted-options-new">
            <div class="form-option">
                <label for="guidesX">{{t('horizontal guide spacing','Horizontal guide spacing')}}</label>
                <input v-model="guidesX" type="number" id="guidesX" min="1" max="50" @change="setGuides">
            </div>
            <div class="form-option">
                <label for="guidesY">{{t('vertical guide spacing','Vertical guide spacing')}}</label>
                <input v-model="guidesY" type="number" id="guidesY" min="1" max="50" @change="setGuides">
            </div>
            <div class="form-option">
                <label for="guidesColor">{{t('guide color option','Color')}}</label>
                <input v-model="guidesColor" type="color" id="guidesColor" @change="setGuides">
            </div>
        </div>
    </div>
</template>

<script>
import { settings } from '../../myapp/src/settings.js';
import { beads } from '../../myapp/src/beads.js';
import { guides } from '../../myapp/src/view/guides.js';
import { menu } from '../../myapp/src/menu.js';

const options = [
    {
        key: 'showLocation',
        translateKey: 'show pointer coordinates',
        translateDefault: 'Show pointer coordinates',
        fn: checked => b3.store.mySet('showCoordinates',checked),
        reset: () => b3.store.state.showCoordinates
    },
    {
        key: 'showSymbols',
        translateKey: 'show bead symbols',
        translateDefault: 'Show bead symbols',
        fn: checked => {
            settings.showLetterCodes = checked;
            beads.refreshCanvas();
        },
        reset: () => settings.showLetterCodes
    },
    {
        key: 'showInactiveBeads',
        translateKey: 'show inactive beads',
        translateDefault: 'Show inactive beads',
        fn: checked => {
            settings.showInactiveBeads = checked;
            beads.refreshCanvas();
        },
        reset: () => settings.showInactiveBeads
    },
    {
        key: 'toggleSimpleMode',
        translateKey: 'render as simple blocks',
        translateDefault: 'Render as simple blocks',
        fn: checked => menu.setSimpleMode(checked),
        reset: () => settings.renderColorOnly
    },
    {
        key: 'enableMouseScroll',
        translateKey: 'enable mouse scroll',
        translateDefault: 'Enable mouse scroll',
        fn: checked => {
            settings.preferences.enableMouseScroll = checked;
            settings.update();
        },
        reset: () => settings.preferences.enableMouseScroll
    },
    {
        key: 'showGuides',
        translateKey: 'show guides',
        translateDefault: 'Show Guides',
        fn: checked => menu.showGuides(checked),
        reset: () => !!guides.arr.length
    },
];

export default {
    data() {
        return {
            themes: settings.themes,
            selectedTheme: 'Auto',
            selectedUnits: 'cm',
            showLocation: true,
            showSymbols: false,
            showInactiveBeads: true,
            toggleSimpleMode: false,
            enableMouseScroll: true,
            showGuides: true,
            guidesX: 5,
            guidesY: 5,
            guidesColor: '#00FFFF',
            options
        }
    },
    methods: {
        reset() {
            if (b3.willMigrate) return;

            options.forEach(option => {
                this[option.key] = option.reset();
            });

            this.selectedTheme = settings.theme.displayName;
            this.selectedUnits = settings.preferences.units;

            this.guidesX = settings.guideSpacing?.x;
            this.guidesY = settings.guideSpacing?.y;
            this.guidesColor = settings.guidesColor;
        },
        setTheme() {
            settings.setTheme(this.selectedTheme);
        },
        setUnits() {
            settings.setUnits(this.selectedUnits)
        },
        setOption(str) {
            options.find(element => element.key == str)?.fn(this[str])
        },
        setGuides() {
            settings.guideSpacing.x = this.guidesX;
            settings.guideSpacing.y = this.guidesY;
            settings.guidesColor = this.guidesColor;
            menu.showGuides(true); // this line is needed to refresh guides
        }
    },
    mounted() {
        this.ee.on('launchMenu', () => {
            this.reset();
        });
    }
}
</script>
